import { Button } from '@/cn/ui/button'
import { Input } from '@/cn/ui/input'
import { useToast } from '@/cn/ui/use-toast'
import { ACTIVE_CURRENCY } from '@/utils'
import { useState } from 'react'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const EnterAmount = () => {
  const { toast } = useToast()
  const [amount, setAmount] = useState('')
  const navigate = useNavigate()
  const cancelTx = () => navigate('/dashboard/')
  const acceptPayment = () => {
    if (!amount) return toast({ variant: 'destructive', title: 'Please enter a valid amount' })
    navigate(`accept/${amount}`)
  }

  return (
    <div className={` flex flex-col h-full w-full p-4`}>
      <button onClick={cancelTx} className="absolute left-4 z-10 top-4 p-2 hover:bg-black/10 rounded-full active:hover:bg-black/20">
        <ArrowLeft className=" text-black" />
      </button>
      <div className="flex flex-col gap-4 items-center">
        <div className="text-2xl text-center leading-[40px] font-semibold ">Enter Amount to Charge</div>
        <Input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder={`${ACTIVE_CURRENCY.symbol} 2000`} className="text-center placeholder:text-center" />
        <span className="mb-2 text-xs">Paid in USDC (instant settlement)</span>
      </div>
      <Button className="text-white" onClick={acceptPayment}>
        Generate QR
      </Button>
      <div className="bg-[#FEF3ED] absolute bottom-0 left-[-200px] h-[35vh] rotate-[-11deg] w-[1200px]"></div>
    </div>
  )
}
export default EnterAmount
